<template>
  <el-main class="page-content-margin-unset">
    <div class="table-top dk-li">
      <el-input
        placeholder="请输入案例名称进行搜索"
        v-model="body.keyword"
        clearable
        class="input-with-select dk_input"/>
      <div>
        <span style="line-height: 40px;margin-right:10px">创建时间</span>
        <el-date-picker
          v-model="times"
          clearable
          value-format="yyyy-MM-dd"
          @change="onTimeChange()"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"/>
      </div>
      <el-button
        type="primary"
        @click="search()">
        搜索
      </el-button>
      <el-button @click="event().clearKeyword()">重置</el-button>
    </div>
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick">
      <el-tab-pane
        label="全部"
        name="all">
        <!-- 表格 -->
        <el-table
          border
          :data="tableData">
          <el-table-column
            prop="uuid"
            label="案例编号"/>
          <el-table-column
            prop="priority"
            label="排序"/>
          <el-table-column
            prop="name"
            label="案例名称"/>
          <el-table-column
            prop="avatar"
            label="封面小图"
            width="161">
            <template slot-scope="scope">
              <img
                :src="imgDomain+'/'+scope.row.index_img"
                width="141px">
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"/>
          <el-table-column
            prop="is_audit"
            label="状态"/>
          <el-table-column
            fixed="right"
            label="操作"
            width="330">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toDetailClick(scope.row.uuid)">
                详情
              </el-button>
              <el-button
                v-if="scope.row.is_audit === '待审核'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toConfirmClick(scope.row.uuid)">
                通过
              </el-button>
              <el-button
                v-if="scope.row.is_audit === '待审核'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toRefuseClick(scope.row.uuid)">
                拒绝
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="待处理"
        name="pending">
        <el-table
          border
          :data="tableData">
          <el-table-column
            prop="uuid"
            label="案例编号"/>
          <el-table-column
            prop="priority"
            label="排序"/>
          <el-table-column
            prop="name"
            label="案例名称"/>
          <el-table-column
            prop="avatar"
            label="封面小图"
            width="161">
            <template slot-scope="scope">
              <img
                :src="imgDomain+'/'+scope.row.index_img"
                width="141px">
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"/>
          <el-table-column
            prop="is_audit"
            label="状态"/>
          <el-table-column
            fixed="right"
            label="操作"
            width="330">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toDetailClick(scope.row.uuid)">
                详情
              </el-button>
              <el-button
                v-if="scope.row.is_audit === '待审核'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toConfirmClick(scope.row.uuid)">
                通过
              </el-button>
              <el-button
                v-if="scope.row.is_audit === '待审核'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toRefuseClick(scope.row.uuid)">
                拒绝
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="已通过"
        name="passed">
        <el-table
          border
          :data="tableData">
          <el-table-column
            prop="uuid"
            label="案例编号"/>
          <el-table-column
            prop="priority"
            label="排序"/>
          <el-table-column
            prop="name"
            label="案例名称"/>
          <el-table-column
            prop="avatar"
            label="封面小图"
            width="161">
            <template slot-scope="scope">
              <img
                :src="imgDomain+'/'+scope.row.index_img"
                width="141px">
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"/>
          <el-table-column
            prop="is_audit"
            label="状态"/>
          <el-table-column
            fixed="right"
            label="操作"
            width="330">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toDetailClick(scope.row.uuid)">
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="已拒绝"
        name="rejected">
        <el-table
          border
          :data="tableData">
          <el-table-column
            prop="uuid"
            label="案例编号"/>
          <el-table-column
            prop="priority"
            label="排序"/>
          <el-table-column
            prop="name"
            label="案例名称"/>
          <el-table-column
            prop="avatar"
            label="封面小图"
            width="161">
            <template slot-scope="scope">
              <img
                :src="imgDomain+'/'+scope.row.index_img"
                width="141px">
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"/>
          <el-table-column
            prop="is_audit"
            label="状态"/>
          <el-table-column
            fixed="right"
            label="操作"
            width="330">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toDetailClick(scope.row.uuid)">
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <!-- 分页组件 -->
    <div class="pagination-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="body.page_index"
        :page-size="body.page_size"
        layout="prev, pager, next"
        :total="total"/>
    </div>

    <!-- 通过案例 -->
    <el-dialog
      width="480px"
      title="提示，是否确认通过 ?"
      :visible.sync="toConfirmBodyDialog">
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="toConfirmBodyDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureToConfirmClick()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 拒绝案例 -->
    <el-dialog
      width="350px"
      title="提示，确认是否拒绝 ?"
      :visible.sync="toRefuseBodyDialog">
      <el-form
        :model="toRefuseBody"
        ref="ruleForm3"
        class="demo-ruleForm">
        <el-input
          placeholder="请输入拒绝理由"
          type="textarea"
          class="dk-input"
          v-model="toRefuseBody.audit_reason"/>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="toRefuseBodyDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureToRefuseClick('ruleForm3')">确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import { getExampleList, setExampleStatus} from '../../api/case'
import { imgDomain } from '../../configs/env'
import timeChange from '../../mixins/time-change'
import { setId } from '../../jslib/set-id'

export default {
  mixins: [timeChange],
  data() {
    return {
      imgDomain,
      body: {
        keyword: '',
        is_user: 'yes',
        page_index: 1,
        page_size: 20,
      },
      times: [],
      total: 0,
      tableData: [
        {},
      ],
      activeName: 'all',
      toConfirmBodyDialog: false,
      toRefuseBodyDialog: false,
      toConfirmBody: {},
      toRefuseBody: {},
    };
  },

  components: {
  },
  created() {
    this.network().getExampleList()
  },
  methods: {
    handleCurrentChange() {
      this.network().getExampleList()
    },
    search() {
      this.network().getExampleList()
    },
    handleClick(tab, event) {
      if (tab.name === 'all') {
        this.body.is_audit = ''
      } else if (tab.name === 'pending') {
        this.body.is_audit = 0
      } else if (tab.name === 'passed') {
        this.body.is_audit = 1
      } else if (tab.name === 'rejected') {
        this.body.is_audit = 2
      }
      this.network().getExampleList()
    },
    event() {
      return {
        clearKeyword: () => {
          this.body.keyword = ''
          this.times = []
          this.body.begin_time = ''
          this.body.end_time = ''
        },
        toConfirmClick: (uuid) => {
          this.toConfirmBody.uuid = uuid
          this.toConfirmBodyDialog = true
        },
        toRefuseClick: (uuid) => {
          this.toRefuseBody.uuid = uuid
          this.toRefuseBodyDialog = true
        },
        onSureToConfirmClick: () => {
          this.toConfirmBody.is_audit = 1;
          this.network().setExampleStatus(this.toConfirmBody)
        },
        onSureToRefuseClick: () => {
          this.toRefuseBody.is_audit = 2;
          this.network().setExampleStatus(this.toRefuseBody)
        },
        toDetailClick: (uuid) => {
          this.$router.push({ path: 'detail', query: { uuid } })
        },
      }
    },
    network() {
      return {
        getExampleList: async () => {
          const { status, data } = await getExampleList(this.body)
          if (status !== 200) return
          this.tableData = setId(data.data, this.body.page_index, this.body.page_size)
          this.tableData = data.data
          this.total = data.total
        },
        setExampleStatus: async (data) => {
          const { status } = await setExampleStatus(data)
          if (status !== 200) return
          this.network().getExampleList()
          if (data.is_audit === 1) {
            this.toConfirmBodyDialog = false
            this.$notify({
              title: '通过成功',
              message: '通过成功',
              type: 'success',
            });
          } else if (data.is_audit === 2) {
            this.toRefuseBodyDialog = false
            this.$notify({
              title: '拒绝成功',
              message: '拒绝成功',
              type: 'success',
            });
          }
        },
      }
    },
    handler() {
      return {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/mixins.scss';
.table-top{
  @include dk-table-top;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/case/audit-list.vue